import { render } from "./TbodyRow.vue?vue&type=template&id=b2c74cce&scoped=true"
import script from "./TbodyRow.vue?vue&type=script&lang=js"
export * from "./TbodyRow.vue?vue&type=script&lang=js"

import "../tailwind.css?vue&type=style&index=0&id=b2c74cce&scoped=true&lang=css&external"
import "./TbodyRow.vue?vue&type=style&index=1&id=b2c74cce&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2c74cce"]])

export default __exports__